import { Pipe, PipeTransform } from '@angular/core';

import { DprCard } from '@dpr/models';
import { WarningType } from '@shared/enums/dpr';
import { DprDetails } from '@shared/models/dpr';

@Pipe({ name: 'warningIcon' })
export class WarningIconPipe implements PipeTransform {
  transform(data: DprCard | DprDetails, property: string): string {
    switch (data?.[property]) {
      case WarningType.Activity:
        return 'error-in-time';
      case WarningType.Weather:
        return 'weather-partly-cloudy';
      case WarningType.HSE:
        return 'lifebuoy';
      case WarningType.Consumable:
        return 'dolly';
      case WarningType.Personnel:
        return 'account-multiple';
      case WarningType.CustomData:
        return 'clipboard-list-outline';
      case WarningType.Progress:
        return 'chart-line';
      case WarningType.ProgressWithoutTarget:
        return 'chart-bar';
      case WarningType.TableOfColumn:
        return 'format-list-bulleted-square';
      default:
        return null;
    }
  }
}
